import React from "react";
import { Check, X } from "lucide-react";

/**
 * What this form draws that the shared kit does not.
 *
 * The four controls that used to live here — the chips list, the number with a
 * unit, the pair of times and the two-answer question — are in
 * `components/ui/FieldControls` now. They were kept in this feature on the rule
 * that a control promoted before it has a second caller is a guess about what
 * that caller will need; the Add client form is that second caller, since it
 * now asks the same questions about a client's body, food, day and health.
 *
 * They are re-exported under the names this feature already refers to them by,
 * so the steps and the review screen import from one place either way. What is
 * still written here is what only this form uses: the card its questions sit
 * in, and the tick and cross the medication question wears.
 */

export {
  ChipsField,
  ChoiceField,
  FieldLabel as Label,
  MeasureField,
  TimeRangeField,
  timeLabel,
} from "../../../components/ui";
export type {
  ChipsFieldProps,
  ChoiceFieldProps,
  MeasureFieldProps,
  TimeRangeFieldProps,
} from "../../../components/ui";

/* ── The white card each group of questions sits in ───────────────────── */

export const Card: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <section className="rounded-xl border border-line bg-white p-5">
    {children}
  </section>
);

/** The tick and the cross the medication question wears. */
export const YesMark = <Check size={18} aria-hidden="true" />;
export const NoMark = <X size={18} aria-hidden="true" />;
